import type { ConceptDef } from '../types';

export const imitateFineMotor: ConceptDef = {
  kind: 'supervisorScored',
  id: 'imitate-fine-motor',
  label: 'Imitate Fine Motor',
  category: 'Motor imitation',
  description: 'Model a fine-motor action; learner imitates. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Open and close your hand.' },
      { prompt: 'Wiggle your fingers.' },
      { prompt: 'Pinch finger and thumb.' },
      { prompt: 'Make a thumbs up.' },
      { prompt: 'Trace a circle in the air.' },
    ],
  },
};
